import { TABLES } from "../../../../../Apis/Tables";
import {
    downloadActionFile,
    EMPTY_VALUES,
    getDateFormat,
    getFullName,
    getTimeFormat
} from "../../../../../Apis/functions";
import CustomCard from "../../../../../components/CustomCard";
import CustomFileCard from "../../../../../components/CustomFileCard";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import CustomUserChip from "../../../../../components/CustomUserChip";
import CustomModal from "../../../../../components/Modal/CustomModal";
import NotInformation from "../../../../../components/NotInformation";
import {
    BuildingModalIcon, EmailSubsectionChip,
    IconClockTable,
    IconScheduleTable, IentryCorporate,
} from "../../../../../components/buttons/IconButtons";
import {
    chipStatusClassColor
} from "../../../../../enums/statusColorEnum";
import { status, STATUS_MODEL } from "../../../../../enums/statusEnum";
import { RequestAccessModalApp } from "../Functionality/RequestAccessModalApp";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const RequestAccessModal = (props) => {
    const { onHide, itemSelected, confirmButton = false, cancelButton = false, buttonConfirm = 'confirm', buttonCancelText = 'dismiss', optionTable = TABLES.REQUEST_ACCESS_EMPLOYEE } = props;

    const { t, requestStatus, assets } = RequestAccessModalApp(props);


    return (
        <CustomModal
            {...props}
            size='lg'
            buttonConfirm={buttonConfirm}
            buttonCancelText={buttonCancelText}
            onHide={() => {
                onHide();
            }}
            confirmButton={confirmButton}
            cancelButton={cancelButton}
            topLeftHeader={
                <>
                    <div className={"d-flex align-items-center pb-3"}>
                        <BuildingModalIcon />
                        <p className={"fs-modal-title font-color-general-950 ml-2"}>{t("access_request")}</p>

                        <div className="vertical-separator-shades-950 h-auto" />
                        <CustomUserChip
                            className={`mt-0 ${chipStatusClassColor[itemSelected?.statusId]}`}
                            name={t(status[itemSelected?.statusId]) || EMPTY_VALUES.DEFAULT}
                            showAvatar={false}
                            variant="large"
                        />
                    </div>
                </>
            }
            classNameBody="pt-2"
        >
            <CustomCard classCard={"card-border-8px"} classContent={"p-0"}>
                {(requestStatus?.id === STATUS_MODEL.REQUESTED) ?
                    <IentryCorporate className={"w-100"} />
                    :
                    <CustomCard
                        classCard={requestStatus?.classCard}
                        children={
                            <div className={`d-flex flex-column justify-content-start gap-3`}>
                                <div className={"gap-2"}>
                                    <p className={`ibl-font-w-600 fs-14px ${requestStatus?.titleClass}`}>{t(requestStatus?.titleTrans)}</p>
                                    <p className={"fs-12px ibl-font-w-600 font-color-shades-800"}>
                                        {t(itemSelected?.statusReason)}
                                    </p>
                                </div>

                                <p className={"fs-12px font-color-shades-600"}>
                                    {t(requestStatus?.byTrans)}
                                    {getFullName(itemSelected?.actionTakenByName, itemSelected?.actionTakenByLastName, itemSelected?.actionTakenBySecondLastName)} · {itemSelected?.actionTakenAt === null ? " - " : getDateFormat(itemSelected?.actionTakenAt)}
                                </p>
                            </div>
                        }
                    />
                }
                {/******* Visitor Information ***********/}
                <div className={"row my-4"}>
                    <div className={"col-12"}> <CustomGenericTittleIconDataChip title={t("visitor_information")} /></div>
                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                        <div className={" d-flex align-items-center"}>
                            <IconScheduleTable className="icon-color-general-950" />
                            <p className={"font-color-general-950 fs-14px ml-2"}>
                                {getFullName(itemSelected?.requestedByName, itemSelected?.requestedByLastName, itemSelected?.requestedBySecondLastName) || EMPTY_VALUES.DEFAULT}
                            </p>
                        </div>
                    </div>
                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                        <div className={" d-flex align-items-center"}>
                            <EmailSubsectionChip />
                            <p className={"font-color-general-950 fs-14px ml-2"}>{itemSelected?.requestedByEmail}</p>
                        </div>
                    </div>
                </div>

                {/******* Employee Information ***********/}
                {optionTable === TABLES.REQUEST_ACCESS_EMPLOYEE &&
                    <div className={"row my-4"}>
                        <div className={"col-12"}> <CustomGenericTittleIconDataChip title={t("employee_information")} /></div>

                        <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                            <div className={" d-flex align-items-center"}>
                                <IconScheduleTable className="icon-color-general-950"/>
                                <p className={"font-color-general-950 fs-14px ml-2"}>
                                    {getFullName(itemSelected?.visitToName, itemSelected?.visitToLastName, itemSelected?.visitToSecondLastName) || EMPTY_VALUES.DEFAULT}
                                </p>
                            </div>
                        </div>
                        <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                            <div className={" d-flex align-items-center"}>
                                <EmailSubsectionChip />
                                <p className={"font-color-general-950 fs-14px ml-2"}>{itemSelected?.visitToEmail || EMPTY_VALUES.DEFAULT}</p>
                            </div>
                        </div>
                    </div>
                }


                <div className={"row my-4"}>
                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                        {/******* Date ***********/}
                        <CustomGenericTittleIconDataChip title={t("date")} />

                        <div className={"mt-2"}>
                            <div className={" d-flex align-items-center"}>
                                <IconScheduleTable className="icon-color-general-950"/>
                                <p className={"font-color-general-950 fs-14px ml-2"}>
                                    {getDateFormat(itemSelected?.createdAt, false)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                        {/******* Time ***********/}
                        <CustomGenericTittleIconDataChip title={t("time")} />

                        <div className={"mt-2"}>
                            <div className={"d-flex align-items-center"}>
                                <IconClockTable className="icon-color-general-950" />
                                <p className={"font-color-general-950 fs-14px ml-2"}>
                                    {getTimeFormat(itemSelected?.createdAt)}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row my-4"}>
                    <div className={"col-12"}>
                        {/******* Purpose of visitor ***********/}
                        <CustomGenericTittleIconDataChip title={t("purpose_of_visit")} />
                        <span className={"font-color-general-950 fs-14px ml-2"}>{itemSelected?.requestReason}</span>
                    </div>
                </div>

                <div className={"row my-4"}>
                    <div className={"col-12"}>
                        {/******* Attached documents ***********/}
                        <CustomGenericTittleIconDataChip title={t("attached_documents")} />

                        {assets?.length === 0 ?
                            <div className={"mt-2"}>
                                <NotInformation
                                    text={t('no_documentation_was_provided')}
                                    card={true}
                                    image={false}
                                    className={"h-auto"}
                                    classNameImage={"h-36px m-0"}
                                />
                            </div>
                            :
                            <>
                                {assets.map(e => {
                                    return <div className={"mt-2"}>
                                        <CustomFileCard
                                            Icon={e.Icon}
                                            title={e.name}
                                            subtitle={<p className={"justify-content-start d-flex ibl-font-w-400 fs-10px"}>{e.size}</p>}
                                            fileValue={e.filePath}
                                            buttonId={"btn_ram_download_" + e.id}
                                            onClick={() => downloadActionFile(e.filePath)}
                                        />
                                    </div>
                                })}
                            </>
                        }

                    </div>
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default RequestAccessModal;
